import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class OtpremnicaService {
  constructor(private _http: HttpClient) {}

  dohvatiOtpremnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_otpremnice', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuOtpremnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jednu_otpremnicu', a)
      .pipe(map((res: any) => res));
  }

  stornirajdokument(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'storno_dokument_i_povezani_dokumenti', a)
      .pipe(map((res: any) => res));
  }

  povezani_dokumenti_popis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'povezani_dokumenti_popis', a)
      .pipe(map((res: any) => res));
  }

  neobradeneNarudzbe_otpremarobe(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'neobradenenarudzbe_otpremarobe', a)
      .pipe(map((res: any) => res));
  }

  poslovnicaPopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPartnere(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'partnerPopis_OtpremaRobe', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPrijevoznike(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_prijevoznike', a)
      .pipe(map((res: any) => res));
  }

  dodajOtpremnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prometzagDodaj', a)
      .pipe(map((res: any) => res));
  }

  zavrsiOtpremnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'zavrsi_otpremnicu_iz_pekara', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProizvode(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_artikle', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLotove(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'provjeri_lot', a)
      .pipe(map((res: any) => res));
  }

  prometzagUredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prometzagUredi', a)
      .pipe(map((res: any) => res));
  }

  prometzagObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prometzagObrisi', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeDodaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeDodaj', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeUredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeUredi', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeObrisi', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJedanDokument(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvatijedandokument_otpremarobe', a)
      .pipe(map((res: any) => res));
  }

  artiklPopisZaPoslovnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'artiklPopisZaPoslovnicu', a)
      .pipe(map((res: any) => res));
  }

  artikli_u_cjeniku_za_partnera(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'artikli_u_cjeniku_za_partnera', a)
      .pipe(map((res: any) => res));
  }

}
